import { OBSTACLE_SUBTYPE, OBSTACLE_TYPE } from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const JUNGL = {
  isDark: true,
  startHealth: 30,
  timeAllowedSecs: 120,
  textColor: "#ffff00",
  textColorHighlight: "#ff6666",
  bgColor: "#022002",
  bgFadeAlpha: 0.65,
  gameplayAreaToCanvasLateralRatio: 1.2,
  player: {
    color: "#ffffff",
    growthDivisor: 200,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 200,
      color_ar: ["#055a03", "#415a03", "#565a03", "#17731e"],
      radiusRange: [5, 7],
      directionRange: [175, 185],
      speedRange: [0.001, 0.03],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      total: 120,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      color_ar: ["#1cbf28", "#62bf1c", "#1cbf4d", "#8bbf1c"],
      radiusRange: [16, 19],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 10,
      color_ar: ["#1cbf28", "#62bf1c", "#1cbf4d", "#8bbf1c"],
      radiusRange: [30, 40],
      directionRange: [120, 240],
      speedRange: [1, 2],
      numAppendagesRange: [5, 9],
      rotationSpeedRange: [0.1, 0.3],
      shapeCenterRadiusDivisor: 3,
      shapeCenterColor_ar: ["#ffffff", "#ffff00", "#ffab03"],
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 10,
      color_ar: ["#1cbf28", "#62bf1c", "#1cbf4d", "#8bbf1c"],
      radiusRange: [60, 70],
      directionRange: [120, 240],
      speedRange: [2, 3],
      numAppendagesRange: [5, 9],
      rotationSpeedRange: [0.5, 0.9],
      shapeCenterRadiusDivisor: 5,
      shapeCenterColor_ar: ["#ffff00", "#ffaaaa"],
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      total: 10,
      color_ar: ["#1cbf28", "#62bf1c", "#1cbf4d", "#8bbf1c"],
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      radiusRange: [50, 60],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 10,
      color_ar: ["#1cbf28", "#62bf1c", "#1cbf4d", "#8bbf1c"],
      radiusRange: [60, 70],
      directionRange: [120, 240],
      speedRange: [3, 4],
      numAppendagesRange: [5, 9],
      rotationSpeedRange: [1, 1.5],
      shapeCenterRadiusDivisor: 4,
      shapeCenterColor_ar: ["#ffffff", "#ffff00", "#ffab03"],
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 15,
      color_ar: ["#ff0000"],
      radiusRange: [6, 7],
      directionRange: [120, 240],
      speedRange: [3, 4],
    },
  ],
};
